import PropTypes from 'prop-types';

const CancelSubReasonPropType = PropTypes.shape({
  cancelSubReasonId: PropTypes.string,
  isActive: PropTypes.bool,
  isCustomerVisible: PropTypes.bool,
  followUpQuestionId: PropTypes.string,
  sortOrder: PropTypes.number,
  subReasonText: PropTypes.string,
});

const CancelFollowUpQuestionsPropType = PropTypes.shape({
  answerTypeId: PropTypes.string,
  cancelReasonId: PropTypes.string,
  cancelSubReasons: PropTypes.arrayOf(CancelSubReasonPropType),
  isActive: PropTypes.bool,
  isCustomerVisible: PropTypes.bool,
  followUpQuestionId: PropTypes.string,
  sortOrder: PropTypes.number,
  questionText: PropTypes.string,
});

export const CancelReasonPropType = PropTypes.shape({
  index: PropTypes.shape({
    cancelReasonId: PropTypes.string,
    cancelFollowUpQuestions: PropTypes.arrayOf(CancelFollowUpQuestionsPropType),
    cancelReasonText: PropTypes.string,
    isCustomerVisible: PropTypes.bool,
    isActive: PropTypes.bool,
    sortOrder: PropTypes.number,
  }),
});

export const CancelReasonDataPropType = PropTypes.shape(CancelReasonPropType);
